export default __webpack_public_path__ + "static/media/05_DAIF_UseCase_04_06_loop.6bc05817.mp4";